import {JwtTokenFn} from "@me8eon/authentication";
import axios, {Axios} from "axios";

export type ElasticSearchConfig = {
    elasticSearchUrl: string
    axios: Axios
    tokenFn: JwtTokenFn
    blacklistedFields?: string[]
    userEmail?: string  // Optional - used by ACL-enabled tools for permission filtering
}

export type ElasticSearchHit = {
    _index: string;
    _id: string;
    _score: number;
    _ignored: string[];
    _source: {
        [key: string]: any
    };

}

export type ElasticSearchKnnSearchResponse = {
    took: number;
    timed_out: boolean;
    _shards: {
        total: number;
        successful: number;
        skipped: number;
        failed: number;
    };
    hits: {
        total: {
            value: number;
            relation: string;
        };
        max_score: number;
        hits: ElasticSearchHit[];
    };
}

export type ElasticSearchDocSearchResponse = {
    "_index": string,
    "_id": string,
    "_version": 1,
    "_seq_no": 5,
    "_primary_term": 1,
    "found": Boolean,
    "_source": {
        [key: string]: any
    }
}


/**
 * Provides a default configuration for connecting to an Elasticsearch instance.
 * @param elasticSearchUrl
 * @param tokenFn
 */
export function defaultElasticSearchToolConfig(elasticSearchUrl: string, tokenFn: JwtTokenFn): ElasticSearchConfig {
    return {
        elasticSearchUrl,
        axios,
        tokenFn,
        blacklistedFields: ["full_text_embeddings", "vectorisation_model"],
    };
}